import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Section = styled.section`
    padding: 80px 20px;
    text-align: center;
    background: #f9f9f9;
`;

const Title = styled.h2`
    color: #007bff;
    margin-bottom: 1.5rem;
`;

const Text = styled.p`
    max-width: 700px;
    margin: 0 auto;
    font-size: 1.1rem;
    line-height: 1.6;
`;

const Image = styled.img`
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  margin-top: 2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

export const About: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Section id="about">
            <Title>{t("about.title")}</Title>
            <Text>{t("about.text")}</Text>
            <Image src="images/about.png" alt="About us" />
        </Section>
    );
};
